// extracted by mini-css-extract-plugin
export default {"container":"FullPageGridLayout_container__6ixgs"};